import useCustomEventListener from "./useCustomEventListener";

const EVENT_NAME = "product-callback-event";

const useProductCallbackListener = (callback) => {
    useCustomEventListener(EVENT_NAME, callback);
};

export default useProductCallbackListener;
